<script>
    export default {
        name: "dialog-header",
        props: {
            title: String,
            subTitle: String,
            persistent: Boolean
        }
    }
</script>

<template>
    <div class="dialog-header text-white pa-4">
        <div class="d-flex flex-row flex-grow-1 justify-space-between align-center justify-center">
            <div class="d-flex flex-column text-truncate">
                <div class="ma-0">
                    {{title}}
                </div>
                <div v-if="subTitle" class="mt-0 dialog-subtitle">
                    {{subTitle}}
                </div>
            </div>
            <div v-if="!persistent" class="d-flex flex-column">
                <v-btn aria-label="close icon" text @click="$emit('close')">
                    <i class="text-white fa-light fa-xmark fa-fw fa-lg cursor-pointer"/>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .dialog-header {
        background-color: var(--color-primary);
        color: var(--color-text-light);
        padding: 10px 0 10px 16px !important;
        //margin-right: -5px;
        font-size: 22px;
    }

    .dialog-subtitle {
        font-size: 12px;
        font-weight: 100;
    }
</style>
